import { store } from '@/store';
import { getModule } from 'vuex-module-decorators';
import LoanStore from '@/loan/store';
import { Route } from 'vue-router';
import { LoanAPIService } from '@/loan/services/api';

const loanStore = getModule(LoanStore, store);

export const loanStatementsResolver = async (to: Route): Promise<void> => {
	const { loanId } = to.params;
	const statements = await LoanAPIService.getStatements(loanId);

	loanStore.setStatements(statements);
};
